import { NavLink, Link } from "react-router-dom";
import { CrossIcon } from "@/components/CrossIcon";

const LINKS = [
  { label: "Home", path: "/", testid: "nav-link-home" },
  { label: "Fellowship Hall", path: "/fellowship", testid: "nav-link-fellowship" },
  { label: "Read the Bible", path: "/read", testid: "nav-link-read" },
  { label: "Bible Word Study", path: "/word-study", testid: "nav-link-word-study" },
  { label: "Bible Map Gallery", path: "/bible-maps", testid: "nav-link-map-gallery" },
  { label: "Gospel Media", path: "/media", testid: "nav-link-media" },
];

export const Navbar = () => (
  <header className="sticky top-0 z-50 bg-parchment/90 backdrop-blur-md border-b border-ink/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 lg:py-4 flex flex-col lg:flex-row items-center lg:justify-between gap-2.5 lg:gap-0">
      <Link to="/" data-testid="nav-brand-logo" className="flex items-center gap-3 group shrink-0">
        <span className="flex items-center justify-center w-10 h-10 rounded-full bg-ink text-gold group-hover:bg-gold group-hover:text-ink transition-colors duration-300">
          <CrossIcon className="w-4 h-4" />
        </span>
        <span className="leading-tight">
          <span className="block font-serif text-xl sm:text-2xl font-600 text-ink tracking-tight whitespace-nowrap">
            Brother's Immanuel
          </span>
          <span className="block font-mono text-[10px] uppercase tracking-[0.22em] text-gold">
            Gospel-Centered Ministry
          </span>
        </span>
      </Link>

      <nav data-testid="main-nav" className="flex flex-wrap justify-center lg:justify-end items-center gap-1 xl:gap-1 lg:ml-6 xl:ml-8">
        {LINKS.map((l) => (
          <NavLink
            key={l.path}
            to={l.path}
            end={l.path === "/"}
            data-testid={l.testid}
            className={({ isActive }) =>
              `px-2.5 sm:px-3 xl:px-4 py-1.5 lg:py-2 rounded-full text-xs sm:text-sm font-600 whitespace-nowrap transition-colors duration-200 ${
                isActive ? "bg-ink text-parchment" : "text-ink/70 hover:text-ink hover:bg-gold-light"
              }`
            }
          >
            {l.label}
          </NavLink>
        ))}
      </nav>
    </div>
  </header>
);
